export function isMobile() {
    const width = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
    return width <= 768;
}

export function isTablet() {
    const width = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
    return width > 768 && width <= 1026;
}

export function isDesktop() {
    return !isMobile() && !isTablet();
}

export function validateEmail(email) {
    const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)*[a-zA-Z]{2,}))$/;
    return re.test(email);
}

export function rgb2hex(rgb) {
    const color = rgb.match(/^rgba?[\s+]?\([\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?/i);
    return (color && color.length === 4)
        ? (`0${parseInt(color[1], 10).toString(16)}`).slice(-2)
        + (`0${parseInt(color[2], 10).toString(16)}`).slice(-2)
        + (`0${parseInt(color[3], 10).toString(16)}`).slice(-2) : '';
}

/** @description Strips query string and preceding tilda from url
 */
export function stripUrl(url) {
    const regex = /.*(?=\?)/;
    let urlNoParam = url;
    if (regex.test(url)) {
        urlNoParam = regex.exec(url)[0]; // eslint-disable-line prefer-destructuring
    }
    if (urlNoParam.charAt(0) === '~') {
        urlNoParam = urlNoParam.subst(1);
    }
    return urlNoParam;
}

export function getDeviceWidth() {
    return Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
}

export function getDevicePixelRatio() {
    return window.devicePixelRatio;
}

export function appendLinkToHead(rel, href, id) {
    let link = document.querySelector(`#${id}`);
    if (link === null) {
        link = document.createElement('link');
        link.rel = rel;
        link.id = id;
        link.href = href;
        const head = document.querySelector('head');
        head.appendChild(link);
    }
    else {
        link.href = href;
    }
}

export function appendMetaTagToHead(name, content, id) {
    let meta = document.querySelector(`#${id}`);
    if (meta === null) {
        meta = document.createElement('meta');
        meta.name = name;
        meta.id = id;
        meta.content = content;
        const head = document.querySelector('head');
        head.appendChild(meta);
    }
    else {
        meta.name = name;
        meta.content = content;
    }
}

export function deleteLinkFromHead(id) {
    const link = document.querySelector(`#${id}`);
    if (!link) {
        return;
    }
    link.remove();
}

export function createCookie(name, value, expiryDate) {
    let cookieValue = encodeURIComponent(value);
    if (expiryDate instanceof Date && expiryDate.getTime() > Date.now()) {
        // Browsers (like Chromium based) have quirks in how they handle cookies. They may still list expired cookies.
        // Therefore we store expiry additionally in value to do extra checking.
        cookieValue += "|expires=" + expiryDate.getTime();
        document.cookie = `${name}=${cookieValue}; path=/; expires=${expiryDate.toUTCString()}`;
    }
    else {
        // Session cookie (no expires attribute)
        document.cookie = `${name}=${cookieValue}; path=/`;
    }
}

export function createCookieWithDuration(name, value, duration) {
    let expiryDate = new Date(Date.now() + + (duration * 1000));
    createCookie(name, value, expiryDate);
}

export function readCookie(cookieName) {
    const cookies = document.cookie.split("; ");
    const now = Date.now();
    for (let cookieStr of cookies) {
        const [name, val] = cookieStr.split("=");
        if (!val || name !== cookieName) continue;
        const [value, expiresPart] = decodeURIComponent(val).split("|expires=");
        // Browsers (like Chromium based) have quirks in how they handle cookies. They may still list expired cookies.
        // Therefore we store expiry additionally in value to do extra checking.
        if (!expiresPart || parseInt(expiresPart) > now) {
            return value; // valid cookie
        }
        else {
            // Expired ? delete it
            document.cookie = `${cookieName}=; Max-Age=0; path=/`;
            return null;
        }
    }
    return null; // cookie not found
}

export function eraseCookie(name) {
    createCookie(name, '', -1);
}

export function stringToBool(string){
    const dictionary = {
        True: true, False: false, true: true, false: false,
    };
    return dictionary[string] || false;
}

export function getHexBackgroundColor(element){
    return (function(rgb) {
        return '#' + (!rgb ? 'FFFFFF' : rgb2hex(rgb))
    })(getComputedStyle(element).getPropertyValue('background-color'));
}

export function isEditMode() {
    return window.self !== window.top; //checks if running in an iframe
}
